/**
 * @desc 重发
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(messageId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/message/log/resend/${messageId}`, {
      method: "GET",

      ...options,
    }),
  );
}
